import { IComponenteBaseDeCalculoPrimeiroAdquirenteouArrematacao } from '../../interfaces/IBaseDeCalculo';
import NotaFiscalAccordion from '../notaFiscalAccordion/notaFiscalAccordion';
import styles from './notaFiscalList.module.scss';

interface INotaFiscalAccordionProps {
  componentesBaseCalculo: IComponenteBaseDeCalculoPrimeiroAdquirenteouArrematacao[];
  setListaComponentesBaseCalculo: React.Dispatch<
    React.SetStateAction<IComponenteBaseDeCalculoPrimeiroAdquirenteouArrematacao[]>
  >;
}

function NotaFiscalList({ componentesBaseCalculo, setListaComponentesBaseCalculo }: INotaFiscalAccordionProps) {
  const excluirBaseDeCalculo = (componente: IComponenteBaseDeCalculoPrimeiroAdquirenteouArrematacao) => {
    //TODO - colocar modal perguntando se quer excluir mesmo
    const novaLista = componentesBaseCalculo.filter(
      (obj) =>
        !(
          obj.notaFiscal === componente.notaFiscal &&
          obj.quantidadeTotal === componente.quantidadeTotal &&
          obj.valorTotal === componente.valorTotal
        )
    );
    setListaComponentesBaseCalculo(novaLista);
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        Lista de Componentes de Base de Cálculo por Documento Fiscal adicionadas à Aquisição
      </div>
      {componentesBaseCalculo.length !== 0 ? (
        <div className={`br-accordion`}>
          {componentesBaseCalculo.map((componenteBaseCalculo, index) => (
            <NotaFiscalAccordion
              key={index}
              componenteBaseCalculo={componenteBaseCalculo}
              excluirBaseDeCalculo={excluirBaseDeCalculo}
            />
          ))}
        </div>
      ) : (
        <p className={styles.text}>Ainda não foram adicionadas componentes de base de cálculo a essa aquisição.</p>
      )}
    </div>
  );
}

export default NotaFiscalList;
